import DesCatalogStatusLogsViewModel from 'viewmodel/DesCatalogStatusLogsViewModel';
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';


/* Class add part to library */
export default class DesCatalogStatusLogs extends DesBaseCatalogAcc {

    constructor() {
        super(DesCatalogStatusLogsViewModel);
    }

    get catalogId() {
        return this.getAttribute(DesAccConstants.CATALOG_ID);
    }

    getProps() {
        return {
            catalogspaceid: this.catalogspaceId,
            provider: this.provider,
            catalogid: this.catalogId,
        };
    }

    static get observedAttributes() {
        return [
            ...DesBaseCatalogAcc.observedAttributes,
            DesAccConstants.CATALOG_ID
        ];
    }

}
if (!window.customElements.get('des-catalog-status-logs')) {
    window.customElements.define('des-catalog-status-logs', DesCatalogStatusLogs);
}
